/**
 * Build responsive URLs for event images served from this API's /api/images/ route,
 * using ?w= and fmt=webp for smaller transfers.
 */

const PLACEHOLDER = "/placeholder-sailing.svg";

export type EventImageVariant = "card" | "detail";

export function buildEventImageAttributes(
  imageUrl: string | null | undefined,
  variant: EventImageVariant,
): {
  src: string;
  srcSet?: string;
  sizes?: string;
  width: number;
  height: number;
} {
  if (!imageUrl) {
    return { src: PLACEHOLDER, width: 800, height: 450 };
  }
  if (!imageUrl.includes("/api/images/")) {
    return { src: imageUrl, width: 800, height: 450 };
  }
  const base = imageUrl.split("?")[0];
  const cardQ = 70;
  if (variant === "card") {
    return {
      src: `${base}?w=800&fmt=webp&q=${cardQ}`,
      srcSet: [
        `${base}?w=400&fmt=webp&q=${cardQ} 400w`,
        `${base}?w=560&fmt=webp&q=${cardQ} 560w`,
        `${base}?w=720&fmt=webp&q=${cardQ} 720w`,
        `${base}?w=800&fmt=webp&q=${cardQ} 800w`,
      ].join(", "),
      sizes:
        "(max-width: 768px) 100vw, (max-width: 1024px) 50vw, (max-width: 1280px) 33vw, 25vw",
      width: 800,
      height: 450,
    };
  }
  const detailQ = 72;
  return {
    src: `${base}?w=1200&fmt=webp&q=${detailQ}`,
    srcSet: `${base}?w=800&fmt=webp&q=${detailQ} 800w, ${base}?w=1200&fmt=webp&q=${detailQ} 1200w, ${base}?w=1600&fmt=webp&q=${detailQ} 1600w`,
    sizes: "(max-width: 768px) 100vw, 896px",
    width: 1200,
    height: 675,
  };
}
